import "@intern/oidc-client"
import {createAuthContext} from "@intern/oidc-client";

let user = null;

export const authContext = createAuthContext({
    authorityUrl: process.env["VUE_APP_KEYCLOAK_URL"] + "/realms/eepos",
    clientId: "base-designer",
    requireLogin: true,
    fallbackRedirectUrl: "",
    onUserLoaded: (newUser) => {
        user = newUser;
    },
    onUserUnloaded: () => {
        user = null;
    },
})

Object.defineProperties(authContext, {
    isAuthenticated: {
        get: function () {
            return user != null;
        }
    }
})